import {loginByUsername} from '@/api/login'
import {getLocalToken, setLocalToken, removeLocalToken, getLocalAccessId, setLocalAccessId, removeLocalAccessId} from '@/utils/auth'
import {getProfile} from '@/api/profile'

const user = {
  state: {
    accessId: getLocalAccessId(),
    user: '',
    status: '',
    code: '',
    token: getLocalToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    authorities: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_ACCESS_ID: (state, id) => {
      state.accessId = id
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_AUTHORITIES: (state, authorities) => {
      state.authorities = authorities
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername ({commit}, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          const data = response.data
          commit('SET_ACCESS_ID', data.id)
          setLocalAccessId(data.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetProfile ({commit, state}) {
      return new Promise((resolve, reject) => {
        getProfile().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
            commit('SET_AUTHORITIES', data.authorities)
          } else {
            reject(new Error('无权限使用'))
            return
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', '/static/logo.png')
          // commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    LogOut ({commit}) {
      return new Promise(resolve => {
        commit('SET_AGENT_ID', 0)
        removeLocalAccessId()
        commit('SET_TOKEN', '')
        removeLocalToken()
        resolve()
      })
    },

    // 动态修改权限
    SetToken ({commit, dispatch}, token) {
      return new Promise(resolve => {
        commit('SET_TOKEN', token)
        setLocalToken(token)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js